import React, { useMemo, useRef, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { clampFrac, easeInQuad, easeOutQuad, pinPositionText, useAnimationFrame } from '../util'
import useStore from '../AppStore'
import path from "../path";


export default function Footer(props) {
  
  const {start, end} = props
  const lang = useStore(state => state.lang)
  const divRef = useRef(null)
  // const year = useMemo(()=>new Date().getFullYear(),[])

  useAnimationFrame(deltaTime => {

    if(divRef.current){
      const top = useStore.getState().top
      const opacity = 1-textOpacity(top, start, end)
      
      divRef.current.style.display = opacity > 0 ? 'block' : 'none'
      divRef.current.style.opacity = opacity

      if(opacity){
        const y = easeOutQuad(clampFrac(top, start, end))
        divRef.current.style.transform = `translate3d(0px,${50-y*50}px,0)`
      }
    }

  })

  return (
    <div ref={divRef} className={`footer-block`}>
      <div className="footer-block--container">
        <h2>
          {lang
          ? <>O futuro está batendo à&nbsp;sua&nbsp;porta. Vai deixar ele esperando?</>
          : <>The future is knocking at your door. Will you open it?</>}
        </h2>
        <p>{lang
          ? <>Cadastre-se já no app InfinitePay.&nbsp;É&nbsp;grátis.</>
          : <>The InfinitePay app is free. Get it now!</>
        }</p>
        <p>
          <a href="#" target="_blank" rel="noreferrer noopener">
            <img src={path + "/assets/badge-googleplay.png"} className='app-badge'/>
          </a>
          &nbsp;&nbsp;
          <a href="#" target="_blank" rel="noreferrer noopener">
            <img src={path + "/assets/badge-appstore.svg"} className='app-badge'/>
          </a>
        </p>

      </div>
      <div className="footer-block--copy">
        <div>
          <a href="#" target="_blank" rel="noreferrer noopener">infinitepay.io</a>
          &nbsp; | &nbsp;
          <a href="#" target="_blank" rel="noreferrer noopener">cloudwalk.io</a>
        </div>
      </div>
    </div>
  )
}

function textOpacity(top, low, high) {
  return top > low ? 1 - clampFrac(top,low,high) : 1
}